var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.opened
    },
    on: {
      "close": function ($event) {
        return _vm.close();
      }
    }
  }, [_c('div', {
    staticClass: "flex flex-col justify-center items-center"
  }, [_c('message-header', {
    staticClass: "w-full",
    attrs: {
      "message-header": _vm.messageHeader
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "mt-10 md:mt-0 text-2xl"
  }, [_vm._v("\n      Attribuer le modèle de page "), _c('br'), _vm._v("« " + _vm._s(_vm.template.name) + " »\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "my-5 text-md text-indigo-600"
  }, [_vm._v("\n      Attribuez ce modèle de page à un ou plusieurs Neopass en cochant les\n      bénéficiaires concernés.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-4 md:space-y-0 md:flex-row w-full justify-between items-center"
  }, [_c('search-bar', {
    staticClass: "w-full md:w-1/3 lg:w-1/4",
    attrs: {
      "value": _vm.search,
      "placeholder": "Rechercher un bénéficiaire"
    },
    on: {
      "input": function (value) {
        return _vm.search = value;
      }
    }
  }), _vm._v(" "), _c('sort-button', {
    attrs: {
      "sort": _vm.sort
    },
    on: {
      "sorted": function (sortType) {
        return _vm.sort = sortType;
      }
    }
  })], 1), _vm._v(" "), _vm.loading ? _c('div', {
    staticClass: "w-full min-h-halfscreen flex justify-center items-center"
  }, [_c('span', {
    staticClass: "p-7 border-t-2 border-r-2 rounded-full animate-spin border-indigo-600"
  })]) : _c('list-grid', {
    attrs: {
      "list-items": _vm.beneficiaries,
      "grid": "grid-cols-12"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('div', {
          staticClass: "col-start-1 col-span-2 md:col-span-1 ml-2 md:ml-5"
        }, [_c('checkbox-indigo', {
          attrs: {
            "value": _vm.allSelected,
            "libelle": "Tous"
          },
          on: {
            "input": function (newValue) {
              return _vm.allSelected = newValue;
            }
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "col-span-2 md:col-span-1 hidden md:inline"
        }), _vm._v(" "), _c('div', {
          staticClass: "col-start-4 md:col-start-auto col-span-8 md:col-span-3 truncate"
        }, [_vm._v("\n          Bénéficiaires\n        ")]), _vm._v(" "), _c('div', {
          staticClass: "md:col-span-3 col-span-4 hidden md:inline"
        }, [_vm._v("\n          Modèle de page actuel\n        ")]), _vm._v(" "), _c('div', {
          staticClass: "md:col-span-3 col-span-4 hidden md:inline"
        }, [_vm._v("\n          Dernière évaluation\n        ")])];
      },
      proxy: true
    }, {
      key: "accordionDescription",
      fn: function (_ref) {
        var item = _ref.item,
          num = _ref.num;
        return [_c('div', {
          staticClass: "col-start-1 col-span-2 md:col-span-1 ml-2 md:ml-5"
        }, [_c('checkbox-indigo', {
          attrs: {
            "value": _vm.selected.includes(item.id)
          },
          on: {
            "input": function (newValue) {
              return newValue ? _vm.select(item.id) : _vm.unselect(item.id);
            }
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "col-span-2 md:col-span-1"
        }, [_c('profile-picture', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.loading,
            expression: "loading"
          }],
          attrs: {
            "loading": "",
            "size": "h-10 w-10"
          }
        }), _vm._v(" "), _c('profile-picture', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !_vm.loading,
            expression: "!loading"
          }],
          attrs: {
            "other-object": item,
            "size": "h-10 w-10"
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "col-span-8 md:col-span-3 flex"
        }, [_vm._v("\n          " + _vm._s(item === null || item === void 0 ? void 0 : item.firstname) + " " + _vm._s(item === null || item === void 0 ? void 0 : item.lastname) + "\n        ")]), _vm._v(" "), _c('div', {
          staticClass: "md:col-span-3 col-span-4 hidden md:inline"
        }, [_vm._v("\n          " + _vm._s(_vm.currentTemplate(item).name) + "\n        ")]), _vm._v(" "), _c('div', {
          staticClass: "md:col-span-3 col-span-4 hidden md:inline"
        }, [_vm._v("\n          " + _vm._s(_vm.lastEval(item))), _c('br'), _vm._v("\n          " + _vm._s(_vm.evaluator(_vm.currentTemplate(item))) + "\n        ")])];
      }
    }])
  }), _vm._v(" "), _c('action-button', {
    staticClass: "my-10",
    attrs: {
      "libelle": "Enregistrer",
      "responsive": "",
      "uppercase": "",
      "icon": "save",
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "type-shadow": "shadow-pink"
    },
    on: {
      "clickAction": _vm.save
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }